import { Interface, BrowserProvider, parseEther, TransactionResponse } from "ethers";

const CUSD_ADDRESS = "0x765DE816845861e75A25fCA122bb6898B8B1282a";

const contractAddress = async (unit: string) => {
  switch (unit) {
    case 'cusd':
      return CUSD_ADDRESS;

    default:
      break;
  }
};

export const triggerWeb3 = async (receiverAddress: string, amount: string, method: string, coin: string) => {
  // const CUSD_ADDRESS = "0x765DE816845861e75A25fCA122bb6898B8B1282a";
  // console.log(formatted, 'formatted');

  const cAddress = await contractAddress(coin);

  console.log(cAddress, 'c address');

  try {

    // Detect if there is an injected wallet.
    if (window.ethereum) {
      // Get connected accounts, if not connected request connnection.
      // returns an array of accounts
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });

      // The current selected account out of the connected accounts.
      const userAddress = accounts[0];

      const iface = new Interface([
        "function transfer(address to, uint256 value)",
      ]);

      const transAmount = parseEther(String(amount));

      const calldata = iface.encodeFunctionData("transfer", [
        receiverAddress,
        transAmount,
      ]);

      const provider = new BrowserProvider(window.ethereum);
      const signer = provider.getSigner();

      let receipt: Promise<TransactionResponse> | string = '';

      // Send transaction to the injected wallet to be confirmed by the user.
      if (method.toLowerCase() === '0x0' && coin.toLowerCase() === 'cusd') {
        // console.log('VALORA METHOD');
        receipt = await window.ethereum.request({
          method: "eth_sendTransaction",
          params: [
            {
              from: userAddress,
              to: cAddress,
              data: calldata,
            },
          ],
        });
      } else {
        // console.log('NON VALORA METHOD');
        receipt = (await signer).sendTransaction({
          from: userAddress,
          to: receiverAddress,
          data: calldata,
          value: transAmount!,
        });
      }

      const result = method?.toLowerCase() === '0x0' ? receipt : await receipt;
      console.log(result, 'RECEIPT');

      return result;
    }

  } catch (error: any) {
    console.log(error, 'THE ERROR');


    return error;
  }

};
